module.exports = {
    standardizePath: function(path) {
        if (typeof path === 'string') {
            return path.replace(/\/{1,}/g, '/')
                .replace(/\/{1,}$/g, '');
        }
    }
}